import React from 'react';
import Image from 'components/AppImage';
import Icon from 'components/AppIcon';

const ClientReviews = () => {
  const reviews = [
    {
      id: 1,
      name: "Rajesh & Priya Sharma",
      location: "Bangalore",
      photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      rating: 5,
      review: "Absolutely incredible experience! The resort was perfect, staff was amazing, and the adventure activities were thrilling. The white water rafting was the highlight of our trip. Definitely coming back!",
      stayDate: "December 2024",
      verified: true
    },
    {
      id: 2,
      name: "Meera Patel",
      location: "Mumbai", 
      photo: "https://images.unsplash.com/photo-1494790108755-2616b612b47c",
      rating: 5,
      review: "Family vacation was made memorable by the excellent hospitality and beautiful surroundings. Kids loved the jungle safari and we enjoyed the peaceful riverside location. Food was delicious!",
      stayDate: "November 2024",
      verified: true
    },
    {
      id: 3,
      name: "Arjun & Kavya",
      location: "Hyderabad",
      photo: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e",
      rating: 5,
      review: "Perfect honeymoon destination! The romantic riverside cottage was exactly what we wanted. Adventure activities were exciting and the sunset views were breathtaking. Thank you for making our special trip unforgettable!",
      stayDate: "January 2025",
      verified: true
    }
  ];

  const renderStars = (rating) => {
    return [...Array(5)]?.map((_, index) => (
      <Icon
        key={index}
        name="Star"
        size={16}
        className={index < rating ? 'text-warning' : 'text-gray-300'}
      />
    ));
  };

  return (
    <section className="py-16 bg-muted">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-4">
            What Our Guests Say
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto font-body">
            Real experiences from real guests who have made unforgettable memories with us
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews?.map((review) => (
            <div
              key={review?.id}
              className="bg-card rounded-2xl shadow-organic p-6 hover-lift"
            >
              {/* Header with Photo and Details */}
              <div className="flex items-start space-x-4 mb-4">
                <div className="flex-shrink-0">
                  <Image
                    src={review?.photo}
                    alt={review?.name}
                    className="w-16 h-16 rounded-full object-cover border-2 border-primary/20"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <h4 className="text-lg font-heading font-semibold text-text-primary truncate">
                      {review?.name}
                    </h4>
                    {review?.verified && (
                      <div className="flex items-center text-success">
                        <Icon name="CheckCircle" size={16} />
                        <span className="text-xs ml-1 font-caption">Verified</span>
                      </div>
                    )}
                  </div>
                  <p className="text-sm text-text-secondary font-caption">
                    {review?.location} • {review?.stayDate}
                  </p>
                  <div className="flex items-center mt-1">
                    {renderStars(review?.rating)}
                  </div>
                </div>
              </div>

              {/* Review Text */}
              <div className="mb-4">
                <blockquote className="text-text-primary font-body italic">
                  "{review?.review}"
                </blockquote>
              </div>

              {/* Bottom Section */}
              <div className="flex items-center justify-between pt-4 border-t border-border">
                <div className="flex items-center text-sm text-text-secondary">
                  <Icon name="Calendar" size={14} className="mr-1" />
                  <span className="font-caption">Stayed in {review?.stayDate}</span>
                </div>
                <div className="flex items-center">
                  {renderStars(review?.rating)}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Stats Section */}
        <div className="mt-16 bg-card rounded-2xl p-8 shadow-organic">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-heading font-bold text-primary mb-2">4.8/5</div>
              <p className="text-text-secondary font-caption">Overall Rating</p>
            </div>
            <div>
              <div className="text-3xl font-heading font-bold text-primary mb-2">1000+</div>
              <p className="text-text-secondary font-caption">Happy Guests</p>
            </div>
            <div>
              <div className="text-3xl font-heading font-bold text-primary mb-2">95%</div>
              <p className="text-text-secondary font-caption">Repeat Visitors</p>
            </div>
            <div>
              <div className="text-3xl font-heading font-bold text-primary mb-2">24/7</div>
              <p className="text-text-secondary font-caption">Guest Support</p>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <h3 className="text-2xl font-heading font-bold text-text-primary mb-4">
            Ready to Create Your Own Memory?
          </h3>
          <p className="text-text-secondary mb-6 font-body">
            Join hundreds of satisfied guests who have experienced the magic of Dandeli
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => window.location.href = '/booking-engine'}
              className="bg-primary text-primary-foreground px-6 py-3 rounded-lg font-heading font-semibold hover:bg-primary/90 transition-organic flex items-center justify-center"
            >
              <Icon name="Calendar" size={18} className="mr-2" />
              Book Your Stay Now
            </button>
            <button
              onClick={() => {
                const message = encodeURIComponent("Hi! I'd like to know more about your resort and make a booking. Can you help me?");
                window.open(`https://wa.me/918277385225?text=${message}`, '_blank');
              }}
              className="border border-primary text-primary px-6 py-3 rounded-lg font-heading font-semibold hover:bg-primary hover:text-primary-foreground transition-organic flex items-center justify-center"
            >
              <Icon name="MessageCircle" size={18} className="mr-2" />
              Chat with Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientReviews;